var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('popup',{attrs:{"fullscreen":false,"width":_vm.width,"height-head":"40px","title":"Preview document","transition":"scale-transition","is-hide-bottom":""},on:{"updateClosePopup":function($event){return _vm.onPreview(null)}}},[_c('embed',{attrs:{"src":_vm.previewLink,"width":_vm.embedWidth,"height":_vm.embedHeight}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }